import { createFileRoute } from '@tanstack/react-router'

import { LocationLookupScreen } from './-components/location-lookup-screen.tsx'

export const Route = createFileRoute('/merchants/location-lookup')({
  component: LocationLookupScreen
})
